import React, { Component, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import Post from 'modules/post/mobile/post.component';
import { getPosts } from 'modules/post/post.actions';
import { globalStyles } from 'app/styles/global';
import CustomListView from 'modules/listview/mobile/customList.component';
import { Box } from 'modules/styled';

let styles;
const POST_PAGE_SIZE = 15;

class Discover extends Component {
  static propTypes = {
    type: PropTypes.string,
    navigation: PropTypes.object,
    tags: PropTypes.object,
    refresh: PropTypes.number,
    active: PropTypes.bool,
    reload: PropTypes.number,
    offsetY: PropTypes.number,
    actions: PropTypes.object,
    auth: PropTypes.object,
    onScroll: PropTypes.func,
    error: PropTypes.bool,
    posts: PropTypes.object,
    loading: PropTypes.bool,
  };

  state = {
    offsetY: 50,
    focusEvent: 1,
    needsReload: new Date().getTime(),
  };

  componentDidMount() {
    const { navigation } = this.props;

    // Needed to re-fire componentDidUpdate on tab change (otherwise blocked by shouldComponentUpdate)
    this.didFocusSubscription = navigation.addListener('didFocus', () => {
      this.setState({ focusEvent: this.state.focusEvent + 1 });
    });
  }

  static getDerivedStateFromProps(props) {
    const { navigation, posts, type: tab } = props;
    const topic = navigation.state?.params?.topic?.id || navigation.state?.params?.topic;
    return {
      topic,
      data: topic ? posts.topics[tab]?.[topic] : posts[tab],
      loaded: topic ? posts.loaded.topics?.[topic]?.[tab] : posts.loaded[tab],
    };
  }

  componentWillUnmount() {
    this.didBlurSubscription?.remove();
  }

  componentDidUpdate(prevProps) {
    const { refresh, active, reload, auth } = this.props;

    if (refresh !== prevProps.refresh && active) {
      if (this.scrollOffset !== -50) this.scrollToTop();
    }

    if (reload !== prevProps.reload) {
      this.setState({ needsReload: new Date().getTime() });
    }

    if (auth.community !== prevProps.auth.community) {
      this.setState({ needsReload: new Date().getTime() });
    }
  }

  shouldComponentUpdate = (next) => next.active && next.navigation.isFocused();

  scrollToTop = () => {
    if (this.listview?.listview)
      this.listview.listview.scrollToOffset({ offset: -this.props.offsetY });
  };

  load = (view, length) => {
    const { topic } = this.state;
    if (!length) length = 0;
    const tags = topic ? [topic] : [];
    const { type: key } = this.props;
    this.props.actions.getPosts(length, tags, key, POST_PAGE_SIZE);
  };

  renderRow = (postId, _, i) => {
    const { posts, type: key } = this.props;
    return <PostEl type={key} postId={postId} posts={posts} index={i} />;
  };

  render() {
    const { auth, onScroll, active, offsetY, error } = this.props;
    const { loading } = this.props;
    const { topic, view, needsReload, loaded, data } = this.state;

    return (
      <Box sx={{ bg: 'white', flex: 1 }}>
        <CustomListView
          ref={(c) => (this.listview = c)}
          key={view + topic + auth.community}
          data={(!loading && data) || []}
          loaded={!loading && loaded}
          renderRow={this.renderRow}
          load={this.load}
          type={'posts'}
          parent={'discover'}
          active={active}
          YOffset={offsetY}
          onScroll={onScroll}
          needsReload={needsReload}
          scrollableTab
          error={error}
        />
      </Box>
    );
  }
}

PostEl.propTypes = {
  posts: PropTypes.object,
  postId: PropTypes.string,
  type: PropTypes.string,
  index: PropTypes.number,
};

function PostEl({ posts, postId, type, index }) {
  const community = useSelector((state) => state.auth.community);
  const post = posts.posts[postId];
  const commentary = useMemo(() => {
    if (!post) return null;
    return post[type]?.map((c) => posts.posts[c]);
  }, [posts.posts, post, type]);

  if (!post) return null;
  if (post?.data?.community !== community) return null;
  const link = posts.links[post.metaPost];

  return (
    <Post
      tooltip={parseInt(index, 10) === 0 || false}
      post={post}
      commentary={commentary}
      link={link}
      styles={styles}
      posts={posts}
    />
  );
}

const localStyles = StyleSheet.create({
  padding20: {
    padding: 20,
  },
  listStyle: {
    height: 100,
  },
  listScroll: {
    height: 100,
    borderWidth: 1,
    borderColor: 'red',
  },
  scrollPadding: {
    marginTop: 300,
  },
});

styles = { ...localStyles, ...globalStyles };

function mapStateToProps(state) {
  return {
    auth: state.auth,
    posts: state.posts,
    animation: state.animation,
    stats: state.stats,
    userList: state.user.list,
    error: state.error.discover,
    refresh: state.navigation.discover.refresh,
    reload: state.navigation.discover.reload,
    loading: state.navigation.discover.loading,
    topics: state.navigation.showTopics,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getPosts,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Discover);
